import { BUTTER, CORAL, INK, LILAC, MINT, PAPER, PEACH, SHAPE_COLORS, SKY, lerpColor } from '../../color';
import type { World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const DEEP = lerpColor(lerpColor(INK, SKY, 0.22), 0x000000, 0.42);

const world: World = {
  id: 'ceu-desenhado',
  name: 'Céu desenhado',
  seed: 'c',
  legacy: true,
  hue: 237,
  ceil: 0x4f4b60,
  font: 'Grandstander',
  fontFile: 'grandstander-900.woff2',
  fontWeight: '900',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.38,
  fillAlpha: 0.74,
  palette: {
    bg: DEEP,
    ink: lerpColor(DEEP, 0x000000, 0.45),
    rim: lerpColor(PAPER, SKY, 0.25),
    held: BUTTER,
    heldShade: lerpColor(PEACH, CORAL, 0.35),
    heldLight: lerpColor(PAPER, BUTTER, 0.3),
    incoming: SHAPE_COLORS,
    spot: LILAC,
    path: lerpColor(PAPER, SKY, 0.4),
    text: PAPER,
    sparks: [BUTTER, PAPER, SKY, LILAC, MINT],
  },
  burst: { count: 12, speed: 0.45, drag: 4, gravity: 0, spin: 2, life: 1, sizeMin: 0.008, sizeMax: 0.02 },
  dress,
  fx,
  paint,
};

export default world;
